import React from 'react'

function SignupInput(props) {
    //input change handler
    const changeHandler = (e) => {
        if (props.active) {
            props.onChange(e.target.value);
        }
    }

    //input enter handler
    const enterHandler = (e) => {
        if (e.keyCode === 13) {
            props.enterAction()
        }
    }

    //input focus handler
    const focusHandler = (e) => {
        e.target.select();
    }

    return (

        <div className={`flex justify-center items-center w-full h-[41%] px-[10%]`}>
            {
                <div
                    className="flex justify-center items-center flex-row-reverse w-full h-full border-b-2">
                    <img src={"https://uploads.zibazi.tv/site/assets/organ/signup/"+props.icon_name} alt="آیکون" className="h-[60%]" />
                    <input onFocus={focusHandler} dir='ltr'
                           disabled={!props.active}
                           className="text-right w-[90%] pr-[5%] h-[90%] rounded-[min(3.5vw,1.7vh)] outline-0 font-semibold font-semiboldFA text-[min(1.1vw,2.2vh)] bg-[#001037] text-[#E9E9E9] placeholder-current   "
                           type={props.type} placeholder={props.placeholder} onKeyDown={enterHandler}
                           onChange={changeHandler} value={props.value}/>
                </div>
            }

        </div>


    )
}

export default SignupInput